import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, type QueryKeyParam } from '../../../query/types';

const consumerPostCheckoutKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'post-checkout'] as const;
  return createQueryKey({
    all: key,
    id: (postCheckoutId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, postCheckoutId] as const,
        receipt: [...key, postCheckoutId, 'receipt'] as const,
        detail: [...key, postCheckoutId, 'detail'] as const,
        redeemableTickets: [...key, postCheckoutId, 'redeemableTickets'] as const,
      }),
    detail: [...key, 'detail'] as const,
  });
};

export { consumerPostCheckoutKeys };
